import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import MyAppointmentsStateService from '../../services/my_appointment_state_service';

export class AppointmentsScheduledController {
  constructor(
    private ngMyAppointmentsStateService: MyAppointmentsStateService,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration
  ) {}

  $onInit() {
    this.ngMyAppointmentsStateService.stateLoaded();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/scheduled/scheduled.ts